

module.exports = __webpack_require__.stylable.create(
    "o9",
    {"classes":{"root":"s316","grid":"s317","content":"s318","bodyArea":"s319","componentMenu":"s320"},"vars":{"color-body-bg":"--o0-color-body-bg","color-primary-light":"--o0-color-primary-light","border-2":"--o0-border-2"},"stVars":{},"keyframes":{}},
    "",
    2,
    10,
    null
);
